export const SETTINGS_HUB_PATH = "/dashboard/settings"

/** Cashiers should not open the tenant settings hub (sidebar or direct URL). */
export function canAccessSettingsHub(role: string | null | undefined): boolean {
  return role !== "Cashier"
}

export const SETTINGS_SECTION_IDS = [
  "appearance",
  "receipts",
  "printers",
  "qz-tray",
  "whatsapp",
  "password",
  "accessibility",
  "features",
  "shift",
  "terminal",
  "cost-method",
  "payment-methods",
  "sales-sources",
  "stock-item-types",
  "restaurant",
  "kitchen-stations",
  "workers",
  "sessions",
  "touch-pos",
] as const

export type SettingsSectionId = (typeof SETTINGS_SECTION_IDS)[number]

export function settingsSectionHref(id: SettingsSectionId): string {
  return `${SETTINGS_HUB_PATH}/${id}`
}

export function isSettingsHubPath(pathname: string): boolean {
  return pathname === SETTINGS_HUB_PATH || pathname === `${SETTINGS_HUB_PATH}/`
}

export function getSettingsSectionId(pathname: string): SettingsSectionId | null {
  if (isSettingsHubPath(pathname)) return null
  if (!pathname.startsWith(`${SETTINGS_HUB_PATH}/`)) return null
  const segment = pathname.slice(`${SETTINGS_HUB_PATH}/`.length).split("/")[0]
  if ((SETTINGS_SECTION_IDS as readonly string[]).includes(segment)) {
    return segment as SettingsSectionId
  }
  return null
}
